import * as React from 'react';
import { Box, Typography, FormControl, Autocomplete, Paper, Container } from '@mui/material';
import { Accordion, AccordionSummary, AccordionDetails, Link, Breadcrumbs } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import axios from 'axios';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { PuffLoader } from 'react-spinners';
import Rectangle from "resources/tools/mitigation-zone/room-shape1.png";
import AreaCalculate from './AreaCalculate';
import 'bootstrap/dist/css/bootstrap.min.css';
import calculator from "resources/tools/mitigation-zone/calculator.png";



function Mainpage() {
  const [material, setMaterial] = useState('');
  const [productResults, setProductResults] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [tubeLength, setTubeLength] = useState('');
  const [refrigerent, setRefrigerent] = useState('Select Refrigerant');
  const [sst, setSST] = useState('');
  const [roomArea, setRoomArea] = useState('');
  const [height, setHeight] = useState(7.2);
  const [calculationResult, setCalculationResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [notFoundErrorMessage, setNotFoundErrorMessage] = useState('');
  const [errors, setErrors] = useState({material: ''});
  const [loading, setLoading] = useState(false);
  const [calculated, setCalculated] = useState(false);
  const [selectedImage, setSelectedImage] = useState(Rectangle);
  const [selectedImageName, setSelectedImageName] = useState('Rectangle');
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const [isAreaCalculatorVisible, setIsAreaCalculatorVisible] = useState(false);
  const [wallErrorMessages, setWallErrorMessages] = useState({});
  const [isCalculateDisabled, setIsCalculateDisabled] = useState(false); // Start with button enabled
  const [isHub, setIsHub] = useState(true);
  const [hubUrl, setHubUrl] = useState('');

  const [dimensions, setDimensions] = useState({
    heightFt: "",
    heightIn: "",
    wall1Ft: "",
    wall1In: "",
    wall2Ft: "",
    wall2In: "",
    wall3Ft: "",
    wall3In: "",
    wall4Ft: "",
    wall4In: "",
    wall5Ft: "",
    wall5In: "",
    wall6Ft: "",
    wall6In: "",
  });

  const handleChange = (event, key) => {
    setCalculationResult(null);
    setErrorMessage(null);
    setNotFoundErrorMessage(null);
    setLoading(false);

    if (!event || !event.target) return;

    let { value } = event.target;

    if (key.includes("In")) {
      if(value > 11) {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          [key]: 'Enter a value <= 11.'
        }));
      }
      else {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          [key]: ''
        }));
      }
    }
    if(key === 'heightFt' || key === 'heightIn') {
      if(dimensions['heightFt'] === '') {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          heightFt: 'Enter a value.'
        }));
      }
      else {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          heightFt: ''
        }));
      }
    }
    if (key.includes("Ft") && key.includes("wall")) {
      let wallIn = key.replace('Ft', 'In');
      if(Number(value) > 900 || (Number(value) === 900 && Number(dimensions[wallIn]) > 5)) {
        setWallErrorMessages((prevMessages) => {
          const updatedMessages = {
            ...prevMessages,
            [key]: 'Enter a value <= 900.',
          };
          console.log("Updated Wall Error Messages:", updatedMessages); // Log the updated state
          return updatedMessages;
        });
      }
      else if(value === '') {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          [key]: 'Enter a value.'
        }));
      }
      else {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          [key]: ''
        }));
      }
    }
    if(key.includes('In') && key.includes('wall')) {
      let wallFt = key.replace('In', 'Ft');
      if((Number(value) > 5 && Number(dimensions[wallFt]) === 900) || Number(dimensions[wallFt]) > 900) {   
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          [wallFt]: 'Enter a value <= 900.'
        }));
      }
      else if(dimensions[wallFt] === '' && value === '') {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          [wallFt]: 'Enter a value.'
        }));
      }
      else {
        setWallErrorMessages((prevMessages) => ({
          ...prevMessages,
          [wallFt]: ''
        }));
      }
    }

    setDimensions((prevState) => ({
      ...prevState,
      [key]: value
    }));
  };
  const calculateWallValueInFeet = (feet, inch) => {
    return Number(feet) + (Number(inch || 0) / 12);
  };

  const calculateHeight = () => {
    const height = Number(dimensions.heightFt) + (Number(dimensions.heightIn) / 12);
    const roundedHeight = Math.round(height);
    if (roundedHeight < 5) {
      setWallErrorMessages((prevMessages) => ({
        ...prevMessages,
        heightFt: 'Please enter height greater than or equal to 5'
      }));
      setErrors({ ...errors, height: 'Please enter height greater than or equal to 5' });
    }
    else if (roundedHeight > 80) {
      setWallErrorMessages((prevMessages) => ({
        ...prevMessages,
        heightFt: 'Enter a value <= 80'
      }));
      setErrors({ ...errors, height: 'Enter a value <= 80' });
    }
    else {
      setWallErrorMessages((prevMessages) => ({
        ...prevMessages,
        heightFt: ''
      }));
      setErrors({ ...errors, height: '' });
    }
    setHeight(roundedHeight);
    return roundedHeight;
  }

  const calculateArea = () => {
    const wall1 = calculateWallValueInFeet(dimensions.wall1Ft, dimensions.wall1In);
    const wall2 = calculateWallValueInFeet(dimensions.wall2Ft, dimensions.wall2In);
    const wall3 = calculateWallValueInFeet(dimensions.wall3Ft, dimensions.wall3In);
    const wall4 = calculateWallValueInFeet(dimensions.wall4Ft, dimensions.wall4In);
    const wall5 = calculateWallValueInFeet(dimensions.wall5Ft, dimensions.wall5In);
    const wall6 = calculateWallValueInFeet(dimensions.wall6Ft, dimensions.wall6In);

    let area = 0;
    if(!(wallErrorMessages.heightFt || wallErrorMessages.heightIn || wallErrorMessages.wall1Ft || wallErrorMessages.wall1In || wallErrorMessages.wall2Ft || wallErrorMessages.wall2In || wallErrorMessages.wall3Ft || wallErrorMessages.wall3In || wallErrorMessages.wall4Ft || wallErrorMessages.wall4In || wallErrorMessages.wall5Ft || wallErrorMessages.wall5In || wallErrorMessages.wall6Ft || wallErrorMessages.wall6In)) {
      if (selectedImageName === "Rectangle") {
        area = Math.round(wall1 * wall2);
      } else if (selectedImageName === "L shape") {
        area = Math.round((wall1 * (wall2 + wall4)) + (wall3 * wall4));
      } else if (selectedImageName === "U shape") {
        area = Math.round((wall1 * wall6) + (wall5 * wall6) + ((wall6 - wall2) * wall3));
      }
    }
    return area > 0 ? area : null;
  };

  const handleInputChange = (newInputValue) => {
    setCalculationResult(null);
    setErrorMessage(null);
    setNotFoundErrorMessage(null);
    setLoading(false);
    setIsCalculateDisabled(false); // Enable the Calculate button when input changes

    const upperCaseValue = newInputValue.toUpperCase();
    setMaterial(upperCaseValue);

    if (upperCaseValue.length >= 2 && upperCaseValue.charAt(1) !== 'E') {
      setProductResults([]);
      errors['material'] = 'Applicable only for Unit Coolers';
    }
    else if (upperCaseValue === null || upperCaseValue === '') {
      setProductResults([]);
      errors['material'] = 'Please enter material number';
    }
    else {
      errors['material'] = '';
    }
  };

  const handleRefrigerantChange = (event) => {
    setRefrigerent(event.target.value);
    setCalculationResult(null);
    setErrorMessage(null);
    setLoading(false);
    setNotFoundErrorMessage(null);
    setIsCalculateDisabled(false); // Enable the Calculate button when refrigerant changes
  };

  const handleShowResult = async () => {
    const productCode = [];
   
    if (isAccordionExpanded && (material === '' ||  sst === '' || roomArea === '' || refrigerent === 'Select Refrigerant' || height === null || height === '' || errors['material'] !== '')) {
      handleValidation('allFields');
      setIsCalculateDisabled(true);
      return;
    }
  
    if (!isAccordionExpanded && (material === '' || refrigerent === 'Select Refrigerant' || errors['material'] !== '')) {
      handleValidation('twoFields');
      setIsCalculateDisabled(true);
      return;
    }
    
    if (isAccordionExpanded && (Object.values(errors).some(error => error !== '') || Object.values(wallErrorMessages).some(error => error !== '' ))  ) {
      setIsCalculateDisabled(true);
      return;
    }
    setIsCalculateDisabled(false);
    setCalculationResult(null);
    setErrorMessage(null);
    setNotFoundErrorMessage(null);
    setLoading(true);


    let endpoint = '';
    let data = {};
    if (isAccordionExpanded) {
      endpoint = isHub ? `/heatcraftwebservices/v2/heatcraft/a2l/product/mitigationzone` : `${hubUrl}/heatcraftwebservices/v2/heatcraft/a2l/product/mitigationzone`;
      data = {
        materialNumber: material,
        refrigerant: refrigerent,
        sst: sst,
        height: height,
        uomLength: "ft",
        roomArea: roomArea,
        tubeLength: tubeLength,
      };
    }
    else {
      endpoint = isHub ? `/heatcraftwebservices/v2/heatcraft/a2l/product/mitigationarea` : `${hubUrl}/heatcraftwebservices/v2/heatcraft/a2l/product/mitigationarea`;
      data = {
        materialNumber: material,
        refrigerant: refrigerent
      }
    }

    try {
      const response = await axios.post(
        endpoint,
        data
      );
      console.log('API Response:', response.data);
      setTubeLength(response.data.tubeLength);
      setErrorMessage('');
      setErrors({material: ''}); 
      setNotFoundErrorMessage('');
      setCalculationResult(response.data);
      setCalculated(true);
    } catch (error) {
      setLoading(false);
      setCalculated(true);
      console.error('Error during calculation:', error);
      setErrorMessage('We did not anticipate this technical issue!! Please try again..');
      if(Array.isArray(error?.response?.data?.errors)) {
        if (error.response.data.errors[0].message.includes('not found')) {
          setNotFoundErrorMessage(error.response.data.errors[0].message);
        }
        else if(error.response.data.errors[0].message.includes('No valid data')) {
          setNotFoundErrorMessage(error.response.data.errors[0].message);
        }
      }
    }
  };

  // Handle Reset
  const handleReset = () => {
    setMaterial('');
    setProductResults([]);
    setRefrigerent('Select Refrigerant');
    setSST('');
    setTubeLength(20);
    setRoomArea('');
    setHeight('7.2');
    setErrorMessage('');
    setWallErrorMessages({});
    setNotFoundErrorMessage('');
    setCalculationResult(null);
    setLoading(false);
    setErrors({material: ''}); // Reset all error messages including tubeLength
    setIsCalculateDisabled(false); // Enable the Calculate button after reset


    setDimensions({
      heightFt: "",
      heightIn: "",
      wall1Ft: "",
      wall1In: "",
      wall2Ft: "",
      wall2In: "",
      wall3Ft: "",
      wall3In: "",
      wall4Ft: "",
      wall4In: "",
      wall5Ft: "",
      wall5In: "",
      wall6Ft: "",
      wall6In: "",
    })
  };

  const handleValidation = (fieldName) => {
    setIsCalculateDisabled(false);
    const formErrors = {};
    if ((fieldName === 'allFields' || fieldName === 'twoFields') && (material === '' || material === null)) {
      formErrors['material'] = 'Please enter material number';
    }
    else if (errors['material'] !== '' && errors['material'] !== null && errors['material'] !== undefined) {
      formErrors['material'] = errors['material'];
    }
    else {
      formErrors['material'] = '';
    }
    if ((fieldName === 'sst' || fieldName === 'allFields') && (sst === null || sst === '')) {
      formErrors['sst'] = 'Please enter SST value'; 
    }
    if ((fieldName === 'roomArea' || fieldName === 'allFields') && (roomArea === null || roomArea === '')) {
      formErrors['roomArea'] = 'Please enter room area';  
    }
    if ((fieldName === 'height' || fieldName === 'allFields') && (height === null || height === '')) {
      formErrors['height'] = 'Please enter height';
    }
    if ((fieldName === 'tubeLength' || fieldName === 'allFields') && (tubeLength === null || tubeLength === '' || tubeLength < 1)) {
      formErrors['tubeLength'] = 'Please enter tube length';
    }
    if ((fieldName === 'allFields' || fieldName === 'twoFields') && refrigerent === 'Select Refrigerant') {
      formErrors['refrigerent'] = 'Please select refrigerant';
    }
    if (height !== null && height !== '' && height < 5) {
      formErrors['height'] = 'Please enter height greater than or equal to 5';
    }
    if (height !== null && height !== '' && height > 80) {
      formErrors['height'] = 'Enter a value <= 80';
    }
    if (sst < -40 || sst > 40) {
      formErrors['sst'] = 'SST value ranges from -40 to 40';
    }
    if(tubeLength < 10 || tubeLength > 150){
      formErrors['tubeLength'] = 'Tube Length value ranges from 10 to 150';
    }
    if (fieldName === 'twoFields') {
      formErrors['sst'] = '';
      formErrors['height'] = '';
      formErrors['roomArea'] = '';
      formErrors['tubeLength'] = '';
    }
    setErrors(formErrors);
  }
  

  const toggleAccordion = () => {
    setIsAccordionExpanded((prev) => {
      const newState = !prev;
      if (!newState) {
        setIsAreaCalculatorVisible(false);
      }
      return newState;
    });
    // Reset errors when toggling accordion
    setErrors(prev => ({
      'material': prev.material
    }))
  };

  const handleImageChange = (image, name) => {
    setSelectedImage(image);
    setSelectedImageName(name);
    setRoomArea('');
  };

  const showAreaCalculator = () => {
    setIsAreaCalculatorVisible(true);
  }

  const clearMaterialInput = () => {
    setMaterial('');
    setProductResults([]);
    setErrors({ ...errors, material: 'Please enter material number' });
  }

  const handleSSTChange = (value) => {
    setSST(value); 
    setCalculationResult({'minRoomArea': calculationResult?.minRoomArea, 'zone': null});
    setErrorMessage(null);
    setNotFoundErrorMessage(null);
    setLoading(false);
  }

  const handleHeightChange = (value) => {
    setHeight(value);
    setCalculationResult({'minRoomArea': calculationResult?.minRoomArea, 'zone': null});
    setErrorMessage(null);
    setNotFoundErrorMessage(null);
    setLoading(false);
  }

  const handleRoomAreaChange = (value) => {
    setRoomArea(value);
    setCalculationResult({'minRoomArea': calculationResult?.minRoomArea, 'zone': null});
    setErrorMessage(null);
    setNotFoundErrorMessage(null);
    setLoading(false);
  }
  // Only set default tubeLength to 20 on initial mount
  useEffect(() => {
    handleChange();
    if (dimensions.heightFt !== '' || dimensions.heightIn !== '') {
      calculateHeight();
    } else if (dimensions.heightFt === '' && dimensions.heightIn === '') {
      setHeight(7.2);
      setErrors({ ...errors, height: '' });
    }
  }, [dimensions]);

  useEffect(() => {
    // Set default tubeLength to 20 only on first mount
    if (tubeLength === '') {
      setTubeLength(20);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Load appSetting.json to get is_hub value
    const loadAppSettings = async () => {
      try {
        const response = await fetch('/resources/tools/mitigation-zone/appSetting.json');
        const settings = await response.json();
        setIsHub(settings.is_hub || false);
        setHubUrl(settings.service_url || '');
      } catch (error) {
        console.error('Error loading appSetting.json:', error);
      }
    };
    
    loadAppSettings();

  }, []);

  return (
    <div className='mitigation-app'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            {isHub && (
              <div className="mitigationHeader">
                <Typography variant="h3" component="h3">
                  Mitigation Zone
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-12 input-container-card">
            <Card sx={{ margin: '0', width: '100%' }} className='card'>
              <Grid item xs={12} className='left-mitigation'>
                <h2>Evaporator Selector</h2>
                <div className='row'>
                  <div className='col-6'>
                    <div className='form-field'>
                      <label htmlFor="materialNumber">Material Number <span className="required-symbol">*</span></label>
                      <input
                        id="materialNumber"
                        className='user-input'
                        value={material}
                        style={{ width: '100%' }}
                        onChange={(e) =>
                          handleInputChange(e.target.value)
                        }
                      />
                      <span className="error-message">{errors["material"]}</span>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='form-field'>
                      <FormControl fullWidth>
                        <label htmlFor="refrigerant-select">Refrigerant <span className="required-symbol">*</span></label>
                        <select
                          id="refrigerant-select"
                          className='user-input'
                          value={refrigerent}
                          onChange={handleRefrigerantChange}
                        >
                          <option value="Select Refrigerant">Select Refrigerant</option>
                          <option value="R455A">R-455A</option>
                          <option value="R454A">R-454A</option>
                          <option value="R454C">R-454C</option>
                        </select>
                      </FormControl>
                      {refrigerent === 'Select Refrigerant' && <span className="error-message">{errors["refrigerent"]}</span>}
                      <p className="note-message"><b>Note:</b> For A2L refrigerants, Mitigation zone as per the UL regulatory requirements are determined with area and height.</p>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-12'>
                    <div className='accordian_change'>
                      <Accordion expanded={isAccordionExpanded}>
                        {isAccordionExpanded && (
                          <AccordionDetails>
                            <div className='row'>
                              <div className="col-6">
                                <div className='form-field'>
                                  <label htmlFor="sst">Sat. Suction Temp. (SST) <span className="required-symbol">*</span></label>
                                  <div className='input-container'>
                                    <input
                                    type="number"
                                    id="sst"
                                    className='user-input'
                                    value={sst}
                                    onKeyDown={(evt) => ["e", "E", "+"].includes(evt.key) && evt.preventDefault()}
                                    onChange={(e) => handleSSTChange(e.target.value)}
                                    onKeyUp={(e) => handleValidation('sst')}
                                    />
                                    <span className='unit'>°F</span>
                                  </div>
                                  <span className="error-message">{errors["sst"]}</span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className='form-field'>
                                  <label htmlFor="height">Height <span className="required-symbol">*</span></label>
                                  <div className='input-container'>
                                    <input
                                      type='number'
                                      id="height"
                                      className='user-input'
                                      value={height}
                                      onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                      onChange={(e) => handleHeightChange(e.target.value)}
                                      onKeyUp={(e) => handleValidation('height')}
                                    />
                                    <span className='unit'>ft</span>
                                  </div>
                                  <span className="error-message">{errors["height"]}</span>
                                  <p className="note-message"><b>Note</b> - 7.2 ft is UL maximum height for calculation. Enter new height if the room height is less than 7.2 ft.</p>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className='m-accordian-input-container'>
                                  <div className='form-field'>
                                    <label htmlFor="roomArea">Room Area <span className="required-symbol">*</span></label>
                                    <div className='input-container'>
                                      <input
                                        type='number'
                                        id="roomArea"
                                        className='user-input'
                                        value={roomArea}
                                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                        onChange={(e) => handleRoomAreaChange(e.target.value)}
                                        onKeyUp={(e) => handleValidation('roomArea')}
                                      />
                                      <span className='unit'>ft²</span>
                                    </div>
                                    <span className="error-message">{errors["roomArea"]}</span>
                                    <p className="note-message"><b>Note</b> - Enter room area to determine mitigation zone.</p>
                                  </div>
                                </div>
                                
                              </div>
                              <div className="col-6">
                                <div className='m-accordian-input-container'>
                                  <div className='form-field'>
                                    <label htmlFor="tubeLength">Tube Length <span className="required-symbol">*</span></label>
                                    <div className='input-container'>
                                      <input
                                        type='number'
                                        id='tubeLength'
                                        className='user-input'
                                        value={tubeLength}
                                        min='1'
                                        step='1'
                                        required
                                        onChange={(e) => {
                                          // Only allow integers
                                          const val = e.target.value;
                                          if (/^\d*$/.test(val)) {
                                            setTubeLength(val);
                                          }
                                        }}
                                        onKeyUp={() => handleValidation('tubeLength')}
                                        onKeyDown={(e) => {
                                          // Prevent decimal and e/E/+/-, and .
                                          if (["e", "E", ".", "+", "-"].includes(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      <span className='unit'>ft</span>
                                    </div> 
                                    <span className="error-message">{errors["tubeLength"]}</span>
                                  </div>
                                </div>
                                
                              </div>
                              <div className="col-lg-6 col-md-12 col-12">
                                <Box className='button-container'>
                                  <img src={calculator} alt="Selected Shape" style={{ width: '35px' }} />
                                  <div style={{ marginLeft: '15px' }}>
                                    <p className='area-calculate-title'>Need help with Room Area Calculations?</p>
                                    <a href="#" onClick={showAreaCalculator} className='area-calculate-button'>Use Room Area Calculator</a>
                                  </div>
                                </Box>
                              </div>
                            
                            </div>
                          </AccordionDetails>
                        )}
                        <AccordionSummary >
                          <strong style={{ color: '#48C1E1' }} onClick={toggleAccordion}>{isAccordionExpanded ? "- View Mitigation Area Only" : "+ View Advanced (Mitigation Zone)"}</strong>
                        </AccordionSummary>
                      </Accordion>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-12'>
                    <AreaCalculate
                      calculateArea={calculateArea}
                      selectedImage={selectedImage}
                      selectedImageName={selectedImageName}
                      handleImageChange={handleImageChange}
                      dimensions={dimensions}
                      handleChange={handleChange}
                      isAreaCalculatorVisible={isAreaCalculatorVisible}
                      wallErrorMessages={wallErrorMessages}
                      setRoomArea={setRoomArea}
                    />
                  </div>
                </div>


              </Grid>
            </Card>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <Card sx={{ margin: '0', background: '#fff', width: '100%', border: '3px solid #45b8dc !important', height: '100%' }} className='card'>
              <div className='right-mitigation' style={{ height: '100%' }}>
                <h2>Mitigation Details</h2>
                <div style={{ height: 'auto' }}>
                  {errorMessage ? (
                    <>
                      {!notFoundErrorMessage && <Card className='card error-card'><p>Sorry !</p><p color="errorMsg">{errorMessage}</p></Card>}
                      {notFoundErrorMessage && <Card className='card error-card notFoundMsg'><p color="errorMsg">{notFoundErrorMessage}</p></Card>}
                    </>
                  ) : (
                    <>
                      {(loading && !calculationResult) && <PuffLoader color="#2d6fb7" size={80} aria-label="puff-loading" className='puff-loader' />}
                      {(calculationResult || !loading) && (
                        <div style={{ height: '100%' }}>
                          <div style={{ height: (isAccordionExpanded || calculationResult == null) ? 'auto' : '100%' }}>
                            <p style={{ marginBottom: '10px' }} className='result-title'>Minimum Room Area </p>
                            <Card className='card result-card'>
                              <p className='resultMsg' style={{ fontSize: '58px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75%' }}>{calculationResult?.minRoomArea ? Number(calculationResult.minRoomArea).toLocaleString() : ''} {calculationResult?.minRoomArea && <span>&nbsp;ft²</span>}</p>
                            </Card>

                              {!isAccordionExpanded && calculationResult?.tubeLength != null && (
                                <>
                                  <b> *Note: The minimum room area requirement applies to a tube length of {calculationResult?.tubeLength ? Number(calculationResult.tubeLength).toLocaleString() : ''} ft.</b>
                                </>
                              )}
                            
                            {isAccordionExpanded && <><p style={{ marginBottom: '10px' }} className='result-title'>Mitigation Zone</p>
                             <Card className='card result-card' style={{ background: calculationResult?.zone === 'NOT ALLOWED' ? '#FFA500' : '#45b8dc' }}>
                              <p className='resultMsg'>
                                {calculationResult?.zone}
                              </p>
                            </Card></>}
                          </div>
                          <div className='mitigation-details'>
                            {(isAccordionExpanded && calculationResult && (calculationResult.zone)?.toUpperCase() === 'CIRCULATION') && <p><b>Circulation: </b>Requires Safety Shutoff Valve activation and turns on Unit Cooler fans to circulate the air.</p>}
                            {(isAccordionExpanded && calculationResult && (calculationResult.zone)?.toUpperCase() === 'NOT ALLOWED') && <p><b>Not Allowed: </b>Equipment is not allowed to be installed if Equipment Amin (Room Minimum Area) is greater than the room area where the equipment is being installed.</p>}
                            {(isAccordionExpanded && calculationResult && (calculationResult.zone)?.toUpperCase() === 'VOLUME') && <p><b>Volume: </b>Requires Safety Shutoff Valve activation. No additional mitigation action required.</p>}
                            {(isAccordionExpanded && calculationResult && (calculationResult.zone)?.toUpperCase() === 'VENTILATION') && <p><b>Ventilation: </b>Requires Safety Shutoff Valve activation and turns on exhaust fans to ventilate refrigerated space.</p>}
                          </div>
                            {isAccordionExpanded && (
                              <div style={{ marginTop: '5px' }}>
                                {calculationResult && (calculationResult?.defaultSsov && calculationResult?.defaultCsov) && (
                                  <>
                                    <p style={{ marginBottom: '5px' }} className='result-title'>
                                      SAFETY SHUTOFF VALVE
                                    </p>
                                    <Card className='card result-card'>
                                      <span>{calculationResult.defaultSsov}</span>
                                    </Card>

                                    <p style={{ marginBottom: '5px' }} className='result-title'>
                                      SAFETY CHECK VALVE
                                    </p>
                                    <Card className='card result-card'>
                                      <span>{calculationResult.defaultCsov}</span>
                                    </Card>
                                     <b> *Note: Applicable for 1 unit cooler, 1 condensing unit systems only</b>
                                  </>
                                )}
                              </div>
                            )}

                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="submitbtns">
              <Stack spacing={2} direction="row">
                <Button variant="contained" onClick={handleReset} className='action-button btn_new'>Reset</Button>
                <Button 
                  variant="contained" 
                  onClick={handleShowResult} 
                  className='action-button btn_new'
                  disabled={isCalculateDisabled}
                >
                  Calculate
                </Button>
              </Stack>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mainpage;